import React from "react"

import { ErrorOutline as ContactNotFoundIcon } from "@material-ui/icons"

import { ChatBotFlowBlockRule } from "@/protocols/chatBot"

import BlockBodySection from "@/pages/Admin/Flow/FlowConstructor/FlowEditor/components/BlockBodySection"
import BlockBodySectionHandle from "@/pages/Admin/Flow/FlowConstructor/FlowEditor/components/BlockBodySectionHandle"
import BlockBodySectionRequiredCondition from "@/pages/Admin/Flow/FlowConstructor/FlowEditor/components/BlockBodySectionRequiredCondition"

import { getConditionRuleByValidationSlug } from "@/pages/Admin/Flow/FlowConstructor/FlowEditor/utils/chatBotFlowBlockRule"

type ContactNotFoundConditionSectionProps = {
	nextChatBotFlowBlockRules: ChatBotFlowBlockRule[]
	text: string
}

const ContactNotFoundConditionSection: React.FC<ContactNotFoundConditionSectionProps> = (props) => {
	const {
		nextChatBotFlowBlockRules,
		text
	} = props

	const contactNotFoundConditionRule = getConditionRuleByValidationSlug("superlogica-contact-not-found", nextChatBotFlowBlockRules)

	if (!contactNotFoundConditionRule) {
		return null
	}

	return (
		<BlockBodySection>
			<BlockBodySectionHandle
				chatBotFlowBlockRule={contactNotFoundConditionRule}
			>
				<BlockBodySectionRequiredCondition
					text={text}
					icon={<ContactNotFoundIcon />}
				/>
			</BlockBodySectionHandle>
		</BlockBodySection>
	)
}

export default ContactNotFoundConditionSection
